/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { LinqService, QueryOptions } from 'linquest';
import {
  PreviousPerformanceFormDetailDto,
  PreviousPerformanceFormDetailViewModel,
  YearParameter,
} from './models';

import { IAjaxProvider } from 'jinqu';

/**
 * PreviousPerformanceFormDetailApi - API class
 */
export class PreviousPerformanceFormDetailApi extends LinqService {

  /**
   * Creates a new PreviousPerformanceFormDetailApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: PreviousPerformanceFormDetailDto, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/GetAsync`;
    let query = this.createQuery<PreviousPerformanceFormDetailDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param yearParams 
   */
  getPreviousPerformanceFormDetailViewModel(yearParams?: YearParameter, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/GetPreviousPerformanceFormDetailViewModel`;
    let query = this.createQuery<PreviousPerformanceFormDetailViewModel>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.data = yearParams
    query = query.withOptions(options);

    return query;
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/GetTranslatedAsync`;
    let query = this.createQuery<PreviousPerformanceFormDetailDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/List`;
    let query = this.createQuery<PreviousPerformanceFormDetailDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/ListTranslated`;
    let query = this.createQuery<PreviousPerformanceFormDetailDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: PreviousPerformanceFormDetailDto, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceFormDetail/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
